export type Language = 'en' | 'hi';

export const LANGUAGES: { value: Language; label: string }[] = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'हिन्दी (Hindi)' },
];

// Demo-scope translation: proves the language switch genuinely re-renders
// the UI rather than just saving a preference. Covers the header nav and
// the Settings screen itself — full app-wide translation is a separate,
// larger pass across every screen's copy.
export const translations = {
  en: {
    'nav.home': 'Home',
    'nav.network': 'Network',
    'nav.myProfile': 'My Profile',
    'nav.connectFamilySearch': 'Connect FamilySearch',
    'nav.settings': 'Settings',
    'nav.signOut': 'Sign Out',
    'nav.designSystem': 'Design System',

    'dashboard.headline': 'Bring Your Story',
    'dashboard.headlineAccent': 'to Life.',
    'dashboard.createStory': '+ Create Story',

    'settings.title': 'Settings',
    'settings.subtitle': 'Manage how My Telling Tale looks and works for you.',
    'settings.appearance': 'Appearance',
    'settings.appearance.light': 'Light',
    'settings.appearance.dark': 'Dark',
    'settings.appearance.system': 'System',
    'settings.language': 'Language',
    'settings.textSize': 'Text Size',
    'settings.textSize.compact': 'Compact',
    'settings.textSize.comfortable': 'Comfortable',
    'settings.textSize.large': 'Large',
    'settings.privacy': 'Default Story Privacy',
    'settings.privacy.description': 'Controls who new stories are shared with by default — you can still change it per story.',
    'settings.privacy.family': 'Family only',
    'settings.privacy.private': 'Private (only me)',
    'settings.data': 'Your Data',
    'settings.data.export': 'Export My Stories',
    'settings.data.exportDescription': 'Download everything you’ve written as a JSON file.',
    'settings.dangerZone': 'Danger Zone',
    'settings.dangerZone.deleteAll': 'Delete All My Stories',
    'settings.dangerZone.description': 'Permanently deletes every story you’ve created. This cannot be undone.',
    'settings.account': 'Account',
    'settings.account.memberSince': 'Member since',
    'settings.preferencesNote': 'These preferences are saved on this device/browser.',
  },
  hi: {
    'nav.home': 'होम',
    'nav.network': 'नेटवर्क',
    'nav.myProfile': 'मेरी प्रोफ़ाइल',
    'nav.connectFamilySearch': 'FamilySearch से जोड़ें',
    'nav.settings': 'सेटिंग्स',
    'nav.signOut': 'साइन आउट',
    'nav.designSystem': 'डिज़ाइन सिस्टम',

    'dashboard.headline': 'अपनी कहानी को',
    'dashboard.headlineAccent': 'जीवंत बनाएं।',
    'dashboard.createStory': '+ कहानी बनाएं',

    'settings.title': 'सेटिंग्स',
    'settings.subtitle': 'My Telling Tale आपके लिए कैसा दिखे और काम करे, यह प्रबंधित करें।',
    'settings.appearance': 'रूप',
    'settings.appearance.light': 'लाइट',
    'settings.appearance.dark': 'डार्क',
    'settings.appearance.system': 'सिस्टम',
    'settings.language': 'भाषा',
    'settings.textSize': 'टेक्स्ट आकार',
    'settings.textSize.compact': 'कॉम्पैक्ट',
    'settings.textSize.comfortable': 'सामान्य',
    'settings.textSize.large': 'बड़ा',
    'settings.privacy': 'डिफ़ॉल्ट स्टोरी गोपनीयता',
    'settings.privacy.description': 'नई कहानियाँ डिफ़ॉल्ट रूप से किसके साथ साझा होंगी — आप हर कहानी के लिए इसे बदल सकते हैं।',
    'settings.privacy.family': 'केवल परिवार',
    'settings.privacy.private': 'निजी (केवल मैं)',
    'settings.data': 'आपका डेटा',
    'settings.data.export': 'मेरी कहानियाँ निर्यात करें',
    'settings.data.exportDescription': 'आपने जो कुछ भी लिखा है उसे JSON फ़ाइल के रूप में डाउनलोड करें।',
    'settings.dangerZone': 'खतरे का क्षेत्र',
    'settings.dangerZone.deleteAll': 'मेरी सभी कहानियाँ हटाएं',
    'settings.dangerZone.description': 'आपकी बनाई हर कहानी स्थायी रूप से हटा दी जाएगी। यह पूर्ववत नहीं किया जा सकता।',
    'settings.account': 'खाता',
    'settings.account.memberSince': 'सदस्य बने',
    'settings.preferencesNote': 'ये प्राथमिकताएँ इसी डिवाइस/ब्राउज़र पर सहेजी जाती हैं।',
  },
} satisfies Record<Language, Record<string, string>>;

export type TranslationKey = keyof typeof translations.en;
